/**
 * Centralised route path registry.
 *
 * Add a new entry whenever you add a page so that every consumer
 * (`<Link to={ROUTES.X}>`, `useNavigate()`, route table) references
 * the same string. Never hard-code path literals in components.
 */
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  PROFILE: '/profile',
  SAMPLE: '/sample',
  NOT_FOUND: '*',
} as const

export type RouteKey = keyof typeof ROUTES
export type RoutePath = (typeof ROUTES)[RouteKey]
